import { NgModule } from 'ng-metadata/core';
import { mdAutocompleteProvider } from './md-autocomplete-provider.config';
import './autocomplete.scss';

/**
 * @ngdoc module
 * @name mw.components.autocomplete
 * @description
 *
 * Autocomplete
 */
@NgModule({
    providers: [mdAutocompleteProvider]
})
export class AutocompleteModule {}



// WEBPACK FOOTER //
// ./src/lib/components/autocomplete/autocomplete.module.ts